define(['underscore'], (_)=> {
    const vmQualifyingProperties = ['value', 'aspects', '_propertyName', '_parent',
        '_ancestorChain', '_metadataInfo', '_accessorCode', '_aspects'];

    /** Checks if maybenode is view model node. */
    function isVMNode(maybeNode) {
        if (!maybeNode || !_.isObject(maybeNode)) {
            return false;
        }

        return vmQualifyingProperties.every((qp)=> {
            return qp in maybeNode;
        });
    }

    function unpackIfVMNode(maybeNode) {
        if (isVMNode(maybeNode)) {
            return maybeNode.value;
        }

        return maybeNode;
    }

    /** Miscellaneous utilities for the view model nodes. */
    return {
        /** Checks if maybenode is view model node. */
        'isViewModelNode': isVMNode,
        'unpackIfViewModelNode': unpackIfVMNode,

        /** Cleans item and extracts its true value. */
        'cleanse': (maybeNode)=> {
            return isVMNode(maybeNode) ? maybeNode.value : maybeNode;
        }
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/viewmodel/ViewModelUtil.js